import api from '@/api/api';
import { createQueryParams } from '@/utils/createQueryParams';

const DOMAIN = '/company-departments';

const getAll = async (
	params?: CompanyDepartments.GetCompanyDepartmentsParams,
): Promise<CompanyDepartments.PaginatedCompanyDepartments> => {
	const queryParams = createQueryParams({
		page: params?.page,
		limit: params?.limit,
		company_id: params?.company_id,
	});
	const queryString = queryParams.toString();
	const url = queryString ? `${DOMAIN}?${queryString}` : DOMAIN;
	const { data } = await api.get(url);
	return data;
};

const getById = async (
	id: string,
): Promise<CompanyDepartments.CompanyDepartment> => {
	const { data } = await api.get(`${DOMAIN}/${id}`);
	return data;
};

const create = async (
	body: CompanyDepartments.CreateCompanyDepartment,
): Promise<CompanyDepartments.CompanyDepartment> => {
	const { data } = await api.post(DOMAIN, body);
	return data;
};

const patch = async (
	id: string,
	body: CompanyDepartments.UpdateCompanyDepartment,
): Promise<CompanyDepartments.CompanyDepartment> => {
	const { data } = await api.patch(`${DOMAIN}/${id}`, body);
	return data;
};

const remove = async (
	id: string,
): Promise<CompanyDepartments.CompanyDepartment> => {
	const { data } = await api.delete(`${DOMAIN}/${id}`);
	return data;
};

const linkToCompany = async (
	departmentId: string,
	body: CompanyDepartments.LinkCompanyDepartment,
): Promise<CompanyDepartments.CompanyDepartmentLink> => {
	const { data } = await api.post(`${DOMAIN}/${departmentId}/link`, body);
	return data;
};

const unlinkFromCompany = async (
	departmentId: string,
	companyId: string,
): Promise<CompanyDepartments.CompanyDepartmentLink> => {
	const { data } = await api.delete(
		`${DOMAIN}/${departmentId}/link/${companyId}`,
	);
	return data;
};

const addSector = async (
	departmentId: string,
	body: CompanyDepartments.CreateCompanySector,
): Promise<CompanyDepartments.CompanySector> => {
	const { data } = await api.post(`${DOMAIN}/${departmentId}/sectors`, body);
	return data;
};

const patchSector = async (
	departmentId: string,
	sectorId: string,
	body: CompanyDepartments.UpdateCompanySector,
): Promise<CompanyDepartments.CompanySector> => {
	const { data } = await api.patch(
		`${DOMAIN}/${departmentId}/sectors/${sectorId}`,
		body,
	);
	return data;
};

const removeSector = async (
	departmentId: string,
	sectorId: string,
): Promise<CompanyDepartments.CompanySector> => {
	const { data } = await api.delete(
		`${DOMAIN}/${departmentId}/sectors/${sectorId}`,
	);
	return data;
};

const CompanyDepartmentService = {
	getAll,
	getById,
	create,
	patch,
	remove,
	linkToCompany,
	unlinkFromCompany,
	addSector,
	patchSector,
	removeSector,
};

export { CompanyDepartmentService };
